import { z } from 'zod'

/** Heading variant available. */
export const VariantHeading = z.enum(['h1', 'h2', 'h3'])
export type VariantHeading = z.infer<typeof VariantHeading>

/** Heading colors available. */
export const ColorHeading = z.enum(['primary', 'secondary'])
export type ColorHeading = z.infer<typeof ColorHeading>
